import React from 'react'
import { Helmet } from 'react-helmet'
import {
  ComoSeComponeMiAporteObligatorio,
  EstoyObligadoAAportarAMiAfp,
  EstoyObligadoAAportarSiTengoMasDe65Anios
} from '../../../../components/aportes-y-fondo/tipos-de-aportes/aportes-como-dependientes';

const Content = () => {
  return (
    <>
      <Helmet>
        <title>
          Asegura tu futuro financiero como trabajador independiente. Aporta a
          tu fondo de pensiones | Prima AFP
        </title>
        <meta
          name="title"
          content="Aportes de Trabajadores Dependientes - Prima AFP | Guía Completa"
          data-react-helmet="true"
        />
      </Helmet>

      <section className="tw-mt-8">
        <EstoyObligadoAAportarAMiAfp />
      </section>

      <section className="tw-pt-14 tw-pt-16@lg tw-pb-14 tw-pb-18@lg bg-gray-6">
        <EstoyObligadoAAportarSiTengoMasDe65Anios />
      </section>

      <section className="tw-pt-12 tw-pt-18@lg tw-pb-12 tw-pb-20@lg bg-yellow-1">
        <ComoSeComponeMiAporteObligatorio />
      </section>
    </>
  )
};

export default Content;
